<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Remove Work Orders from Technician Payment Import"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Remove work orders from technician payments."
      @on-submit="createImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Remove Work Orders From Technician Payment Template.xlsx"
              :file-provider="$importsAPI.getRemoveWorkOrdersFromTechnicianPaymentTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RemoveWorkOrdersFromTechnicianPaymentImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'remove-work-orders-from-technician-payment-imports-add-modal',
    };
  },
  methods: {
    createImport(data, handleCreate) {
      handleCreate(this.$importsAPI.removeWorkOrdersFromTechnicianPaymentCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
